<template>
  <div class="section">
    <div class="section__header">
      <h2>Новости Матриуса</h2>
      <back></back>
    </div>

    <div class="section__body">
      <ul v-if="news.length" class="news">
        <li v-for="newsItem in news" :key="newsItem.id" class="news__item">
          <div class="news__header">
            <h3>{{ newsItem.title }}</h3>
            <span> {{ newsItem.updated_at | date }} </span>
          </div> 

          <div class="news__body">
            <p class="news__text" v-html="newsItem.desc"></p>
            <div class="news__image" v-if="newsItem.image">
              <img :src="newsItem.image.path" alt="Изображение">
            </div>
          </div>

          <div class="news__footer">
            <div class="news__text news__text--like">
              <div @click="likeArticle(newsItem)" class="news__like-container">                
                <span                 
                  :class="{
                    active: newsItem.users.find(u => u.id === user.id)
                  }"
                >
                  <i class="fas fa-heart"></i>
                </span> 
                <span>{{ newsItem.users.length }}</span>
              </div>

              <div class="news__like-info">
                <h5 @click="openPopup('MatriusLikeInfo', newsItem.users)">Понравилось ({{ newsItem.users.length }})</h5>
                <ul class="news__like-users">
                  <li v-for="user in newsItem.users.slice(0, 3)" :key="user.id">{{ user.name }}</li>
                  <li v-show="newsItem.users.length > 3">...</li>
                </ul>
              </div>             
            </div>            
          </div>
        </li>
      </ul>
    </div>

    <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
      <template v-slot:content>
        <component
          :is="popupContent"
          :data="popupData"
          @close-popup="popupIsOpened = false"
        ></component>
      </template>
    </Popup>
  </div>
</template>

<script>
import moment from 'moment'
import MatriusLikeInfo from './MatriusLikeInfo.vue'
import { mapState } from 'vuex'
import { popup_mix } from '../../../mixins/popup_mix'
export default {
  inject: ['http'],
  mixins: [ popup_mix ],
  components: { MatriusLikeInfo },
  filters: {
    date: function(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')
    }
  },
  data() {
    return {
      news: []
    }
  },
  computed: {
    ...mapState({
      user: 'user'
    })
  },
  methods: {
    getMatriusNews() {
      this.http.post('onGetArticles').then(res => {
        this.news = res.data
      })
    },
    likeArticle(article) {
      let data = {
        user_id: this.user.id,
        article_id: article.id
      }
      this.http.post('onLikeArticle', data).then(res => {
        let isLiked = article.users.find(item => item.id === this.user.id)
        if (isLiked) {
          let index = article.users.indexOf(isLiked)
          article.users.splice(index, 1)
        } else {
          article.users.unshift(this.user)
        }        
      })
    }
  },
  created() {
    this.getMatriusNews()
  }
}
</script>
